export const oneYearFromNow = (): Date => {
    const now = new Date();
    return new Date(now.setFullYear(now.getFullYear() + 1));
};
